<template>
  <div class="goals-atlas">
    <atlas-wrapper
      :view-application="viewApplication"
      :default-view="defaultView"
    />
  </div>
</template>

<script>
import AtlasWrapper from '@/components/goal/atlas/AtlasWrapper.vue';
import useLoggedInUserAccount from '@/composables/logged-in-user-account/logged-in-user-account';
import { AND } from 'shared/api/query/constants';
import { viewApplication, viewType } from 'shared/constants.json';

export default {
  name: 'GoalsAtlas',
  components: { AtlasWrapper },
  setup() {
    const { loggedInUserAccount } = useLoggedInUserAccount();
    return { loggedInUserAccount };
  },
  data() {
    return { viewApplication: viewApplication.goal };
  },
  computed: {
    // TODO: Decide if defaultView and data.viewApplication should really be passed by props via "pages"
    defaultView() {
      return {
        title: this.$t('list.atlas'),
        viewType: viewType.atlas,
        viewApplication: this.viewApplication,
        params: {
          filter: { account: { uid: this.loggedInUserAccount.uid }, children: [], op: AND },
          order: [],
          props: [],
          grouping: 'status',
        },
      };
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">

</style>
